import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonGeneratorComponent } from './button-generator.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PermissionsDirective } from '../../directives/permissions.directive';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    TranslocoPipe,
    MatButtonModule,
    MatIconModule,
    PermissionsDirective,
    MatTooltipModule,
  ],
  declarations: [ButtonGeneratorComponent],
  exports: [ButtonGeneratorComponent],
})
export class ButtonGeneratorModuleModule {}
